import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Reset CSS minimal
document.body.style.cssText = 'margin:0;padding:0;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);
